import Layout from '@/layout'
export default [
    {
        path: '/system/user-auth',
        component: Layout,
        hidden: true,
        permissions: ['system:user:edit'],
        children: [
            {
                path: 'role/:userId(\\d+)',
                component: () => import('@/views/system/user/authRole'),
                name: 'AuthRole',
                meta: { title: '分配角色', activeMenu: '/system/user' }
            }
        ]
    },
    {
        path: '/system/role-auth',
        component: Layout,
        hidden: true,
        permissions: ['system:role:edit'],
        children: [
            {
                path: 'user/:roleId(\\d+)',
                component: () => import('@/views/system/role/authUser'),
                name: 'AuthUser',
                meta: { title: '分配用户', activeMenu: '/system/role' }
            }
        ]
    },
    {
        path: '/system/dict-data',
        component: Layout,
        hidden: true,
        permissions: ['system:dict:list'],
        children: [
            {
                path: 'index/:dictId(\\d+)',
                component: () => import('@/views/system/dict/data'),
                name: 'dictData',
                meta: { title: '字典数据', activeMenu: '/system/dict' }
            }
        ]
    },
    {
        path: '/monitor/job-log',
        component: Layout,
        hidden: true,
        permissions: ['monitor:job:list'],
        children: [
            {
                path: 'index',
                component: () => import('@/views/monitor/job/log'),
                name: 'JobLog',
                meta: { title: '调度日志', activeMenu: '/monitor/job' }
            }
        ]
    },
    {
        path: '/tool/gen-edit',
        component: Layout,
        hidden: true,
        permissions: ['tool:gen:edit'],
        children: [
            {
                path: 'index/:tableId(\\d+)',
                component: () => import('@/views/tool/gen/editTable'),
                name: 'GenEdit',
                meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
            }
        ]
    },
    // 实体绑定页面
    {
        path: '/kl/entity-bind',
        component: Layout,
        hidden: true,
        permissions: ['kl:entity:list'],
        children: [
            {
                path: 'bind',
                component: () => import('@/views/kl/entity/bind'),
                name: 'entity-bind',
                meta: { title: '绑定页面', activeMenu: '/kl/bind' }
            }
        ]
    },
    // 公司管理表单页面
    {
        path: '/platform/company-form',
        component: Layout,
        hidden: true,
        permissions: ['system:company:add', 'system:company:edit'],
        children: [
            {
                path: 'index',
                component: () => import('@/views/platform/company/company-form'),
                name: 'CompanyForm',
                meta: { title: '公司表单', activeMenu: '/platform/company' }
            }
        ]
    },
]